<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.viewRoute')"
        size="large"
        :submit="edit ? submit : undefined"
        @close="close">
        <div class="flex w-full h-full gap-3">
            <div class="w-2/3">
                <ul
                    v-if="routingSelected.positions?.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in routingSelected.positions"
                        :key="index"
                        data-content=" "
                        class="step">
                        <div>
                            <div class="flex items-center justify-center w-full">
                                <span class="w-52 flex justify-start">
                                    {{ item.nodeTypeName }}
                                </span>
                                <div class="w-full">
                                    <div
                                        class="tooltip w-full"
                                        :class="{ 'tooltip-bottom': index == 0 }"
                                        :data-tip="item.fullNameNode">
                                        <hts-form-input
                                            v-model="item.fullNameNode"
                                            class="w-full"
                                            readonly />
                                    </div>

                                    <template v-if="getTolltation(routingSelected.positions[index]?._id, routingSelected.positions[index + 1]?._id)?.length">
                                        <h5 class="w-full text-left">
                                            Trạm thu phí:
                                        </h5>
                                        <p
                                            v-for="toll in getTolltation(routingSelected.positions[index]?._id, routingSelected.positions[index + 1]?._id)"
                                            :key="toll"
                                            class="w-full text-left">
                                            {{ toll.locationName }}
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <div
                    v-if="cRouting?.length > 1"
                    class="flex flex-col gap-3 mt-10">
                    <h4>
                        Tuyến chính và trái tuyến
                    </h4>
                    <div
                        v-for="r in cRouting"
                        :key="r"
                        class="text-sm breadcrumbs cursor-pointer hover:bg-primary-400 hover:text-primary-800 p-2 rounded-lg font-bold"
                        :class="{
                            'bg-primary-300 text-primary-800': routingSelected._id === r._id,
                            'bg-slate-200 ': routingSelected._id !== r._id
                        }"
                        @click="handleSelectRoute(r)">
                        <p v-if="r.isMain">
                            Tuyến chính
                        </p>
                        <ul class="flex-wrap">
                            <li
                                v-for="p in r.positions"
                                :key="p">
                                {{ p.nodeLocationName || p.locationName }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="w-full h-full">
                    <hts-map-positions
                        ref="map"
                        :show-location="showLocation"
                        :route-separated="routeSeparated"
                        :route="route"
                        :lat-lng-location-routes="latLngLocationRoutes"
                        center-marker
                        :draggable="cDraggable"
                        @updateDirections="updateDirections">
                        <template #top>
                            <div class="flex min-h-5 justify-end gap-3">
                                <hts-map-icon-draggable
                                    v-if="edit && checkPermission(layoutPermissions.route.edit)"
                                    v-model="draggable" />
                                <hts-map-icon-location />
                            </div>
                        </template>
                    </hts-map-positions>
                </div>
            </div>
        </div>
    </hts-drawer>
</template>

<script lang="ts" setup>
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'
const { $formatters } = useNuxtApp()

const props = defineProps({
  edit: {
    type: Boolean,
    default: true
  }
})

const { edit } = toRefs(props)
const cDraggable = computed(() => edit.value && draggable.value)
const { $disableReactive } = useNuxtApp()
const visible = ref(false)
const map = ref()

const { map: mapStore } = $store()
const emits = defineEmits(['update:routingPositions', 'update:routingPositionsConnections'])

const showLocation = computed(() => {
  return mapStore.getShowLocation
})

const positionData = ref<Array<{ [key: string]: any }>>([]) // tuyến chính
const draggable = ref(false) // vẽ tuyến
const routingPositions = ref({} as { [key: string]: any }) // thông tin vẽ tuyến chinh
const routingPositionsConnections = ref({} as { [key: string]: any }) // thông tin vẽ trái tuyến
const routeSeparated = ref<{ [key: string]: any }>([]) // tuyến đã tách
const route = ref<any>(null) // tuyến all
const routingConnectionsData = ref<{ [key: string]: any }>([]) // trái tuyến
const routingSelected = ref<{ [key: string]: any }>({}) // tuyến đc chọn để show map và vẽ tuyến (tuyến chính và trái tuyến)

const cRouting = computed(() => {
  const data = [] as any[]
  if (!positionData.value) {
    return []
  }

  data.push({ isMain: true, positions: positionData.value, _id: $formatters.generateId() })

  if (!routingConnectionsData.value) {
    return data
  }

  routingConnectionsData.value.forEach((item: any) => {
    data.push({ isMain: false, positions: item, _id: $formatters.generateId() })
  })

  return data
})

const cNodeIds = computed(() => routingSelected.value.positions.map((item: any) => item.node).join('-'))

const close = () => {
  map.value && map.value.resetMap()
  routingPositions.value = {}
  positionData.value = []
  routeSeparated.value = []
  route.value = null
  latLngLocationRoutes.value = []
  draggable.value = false
  routingConnectionsData.value = []
  routingSelected.value = {}
  routingPositionsConnections.value = {}
  visible.value = false
}

const latLngLocationRoutes = ref([] as { [key: string]: any }[])
const open = (data: { [key: string]: any }) => {
  const { positions, routingPositionsData, routingConnectionsData: d, routingPositionsConnections: rpc } = data

  if (!positions?.length || positions.length < 2) {
    return
  }

  visible.value = true

  // tuyến chính
  positionData.value = $disableReactive(positions)
  // trái tuyến
  routingConnectionsData.value = $disableReactive(d)
  // thông tin tuyến chính đã vẻ
  if (routingPositionsData) {
    routingPositions.value = $disableReactive(routingPositionsData)
  }
  // thông tin trái tuyến đã vẻ
  if (rpc) {
    routingPositionsConnections.value = $disableReactive(rpc)
  }

  routingSelected.value = cRouting?.value?.[0] || {}

  routeSeparator()
  setRoute()
}

// setup data để vẻ tuyến
// tách nhỏ tuyến để vẻ A -> B -> C  ==>  A -> B, B -> C
const routeSeparator = () => {
  const r = []
  const positions = routingSelected.value?.positions || []

  for (let i = 0; i < positions?.length - 1; i++) {
    const overViewPolyLine = getOverViewPolyLine(positions[i]._id, positions[i + 1]._id)

    r.push({
      originData: {
        lat: parseFloat(positions[i].lat),
        lng: parseFloat(positions[i].lng)
      },
      destinationData: {
        lat: parseFloat(positions[i + 1].lat),
        lng: parseFloat(positions[i + 1].lng)
      },
      data: {
        startLocation: positions[i]._id,
        endLocation: positions[i + 1]._id,
        nodeLocationName: positions[i].nodeLocationName,
        overViewPolyLine
      }
    })
  }

  const origin = {
    lat: parseFloat(positions[0].lat),
    lng: parseFloat(positions[0].lng)
  }

  const destination = {
    lat: parseFloat(positions[positions?.length - 1].lat),
    lng: parseFloat(positions[positions?.length - 1].lng)
  }

  const options = {
    originLocationName: positions[0].nodeLocationName,
    destinationLocationName: positions[positions?.length - 1].nodeLocationName,
    sameOriginDestination: origin.lat === destination.lat && origin.lng === destination.lng,
    renderMarkerByIndexNumber: true,
    multiple: true
  } as { [key: string]: any }

  routeSeparated.value = {
    routes: r,
    options
  }
}

// set data để render markers điểm trong tuyến
const setRoute = () => {
  const positions = routingSelected.value?.positions || []
  let originData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
  let destinationData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
  let originLocationName = 'A'
  let destinationLocationName = 'B'
  const waypointsData: { location: google.maps.LatLngLiteral; node?: string; locationName?: string }[] = []

  positions.forEach((s: any, i: number) => {
    if (isNaN(s.lat) || isNaN(s.lng)) {
      return
    }
    const lat = parseFloat(s.lat?.toString())
    const lng = parseFloat(s.lng?.toString())

    latLngLocationRoutes.value.push({ lat, lng, locationName: s.locationName } as google.maps.LatLngLiteral)
    const tollStations = getTolltation(positions[i]?._id, positions[i + 1]?._id)

    if (tollStations && tollStations?.length) {
      tollStations.forEach((t: any) => {
        latLngLocationRoutes.value.push({ lat: 0, lng: 0, nodeId: t.locationId, locationName: t.locationName } as google.maps.LatLngLiteral)
      })
    }

    if (i === 0) {
      originData = { lat, lng } as google.maps.LatLngLiteral
      originLocationName = s.nodeLocationName
      return
    }
    if (i === positions.length - 1) {
      destinationData = { lat, lng } as google.maps.LatLngLiteral
      destinationLocationName = s.nodeLocationName
      return
    }

    waypointsData.push({
      location: { lat, lng } as google.maps.LatLngLiteral,
      node: s.node,
      locationName: s.nodeLocationName
    })
  })

  route.value = {
    originData,
    destinationData,
    waypointsData,
    options: {
      originLocationName,
      destinationLocationName,
      sameOriginDestination: originData.lat === destinationData.lat && originData.lng === destinationData.lng,
      renderMarkerByIndexNumber: true
    }
  }
}

const updateDirections = async (directions: any) => {
  // if (!cDraggable.value) {
  //   return
  // }

  if (!directions || !directions.length) {
    return
  }

  const legs = directions
    .map((item: any) => {
      const { routes } = item?.renderer?.directions

      if (!routes || !routes.length) {
        return null
      }

      const route = routes[0]
      if (!route || !route.legs || !route.legs.length) {
        return null
      }

      const ceilSeconds = (seconds: number): number => {
        const minutes = Math.ceil(seconds / 60)
        return minutes * 60
      }

      const leg = route.legs[0]
      const duration = leg.duration ? ceilSeconds(leg.duration.value) : 0
      const distance = leg.distance ? leg.distance.value : 0

      const { startLocation, endLocation } = item.data

      return {
        duration,
        distance,
        startAddress: leg.start_address,
        endAddress: leg.end_address,
        overViewPolyLine: route.overview_polyline,
        startLocation,
        endLocation
      }
    })
    .filter((item: any) => item !== null)

  const duration = $formatters.mToKm($lodash.sumBy(legs, 'duration')) // gio
  const distance = $formatters.mToKm($lodash.sumBy(legs, 'distance')) // km

  let drew = false
  if (draggable.value) {
    drew = true
  }

  if (routingSelected.value.isMain) {
    routingPositions.value = {
      route: {
        duration,
        distance,
        legs,
        drew
      }
    }
  } else {
    routingPositionsConnections.value[cNodeIds.value] = {
      route: {
        duration,
        distance,
        legs,
        drew
      }
    }
  }

  if (legs.length === routingSelected.value.positions?.length - 1) {
    latLngLocationRoutes.value = latLngLocationRoutes.value.filter((item) => !item.nodeId)
    await setTolltation()
  }
}

const setTolltation = async () => {
  const url = $urlClient.quote.quoteRequest.tollStation
  let legs = [] as any[]

  if (routingSelected.value.isMain) {
    legs = routingPositions.value?.route?.legs
  } else {
    legs = routingPositionsConnections.value?.[cNodeIds.value]?.route?.legs
  }

  if (legs) {
    for (let i = 0; i < legs.length; i++) {
      const leg = legs[i]
      const res = await $api(url, { body: { overViewPolyLine: leg.overViewPolyLine } })

      const resData = res?.data?.value

      if (resData.success) {
        // lưu trạm thu phí vào thông tin chuyến
        legs[i].tollStations = resData.data || []

        // vẽ markers trạm thu thí
        if (resData.data && resData.data.length) {
          resData.data.forEach((t: any) => {
            latLngLocationRoutes.value.push({ lat: 0, lng: 0, nodeId: t.locationId, locationName: t.locationName } as google.maps.LatLngLiteral)
          })
        }
      }
    }
  }
}

const getOverViewPolyLine = (startPositionId: string, endPositionId: string) => {
  let legs = [] as any[]
  let drew: boolean = false
  if (routingSelected.value.isMain) {
    legs = routingPositions.value?.route?.legs
    drew = routingPositions.value?.route?.drew
  } else {
    legs = routingPositionsConnections.value?.[cNodeIds.value]?.route?.legs
    drew = routingPositionsConnections.value?.[cNodeIds.value]?.route?.drew
  }

  if (!legs || !legs.length) {
    return null
  }

  if (!drew) {
    return null
  }

  const leg = legs.filter((item: any) => {
    if (item.startLocation === startPositionId && item.endLocation === endPositionId) {
      return true
    }
    return false
  })

  if (!leg || !leg.length) {
    return []
  }

  return leg[0].overViewPolyLine || ''
}

const getTolltation = (startPositionId: string, endPositionId: string) => {
  let legs = [] as any[]

  if (routingSelected.value.isMain) {
    legs = routingPositions.value?.route?.legs
  } else {
    legs = routingPositionsConnections.value?.[cNodeIds.value]?.route?.legs
  }

  if (!legs || !legs.length) {
    return null
  }

  const leg = legs.filter((item: any) => {
    if (item.startLocation === startPositionId && item.endLocation === endPositionId) {
      return true
    }
    return false
  })

  if (!leg || !leg.length) {
    return []
  }

  return leg[0].tollStations || []
}

const handleSelectRoute = (val: any) => {
  routingSelected.value = val
  routeSeparator()
  setRoute()
}

const submit = () => {
  if (routingPositions.value?.route) {
    routingPositions.value.route.drew = true
  }

  const cNodeIdKeys = Object.keys(routingPositionsConnections.value || {}) || []

  cNodeIdKeys.forEach((nodeIds: string) => {
    if (routingPositionsConnections.value?.[nodeIds]?.route) {
      routingPositionsConnections.value[nodeIds].route.drew = true
    }
  })

  emits('update:routingPositions', routingPositions.value)
  emits('update:routingPositionsConnections', routingPositionsConnections.value)
  close()
}

defineExpose({
  open
})
</script>
